import * as React            from "react";
import {cs}                  from "@Common/react/chain-services";

export const prurealty_bus_cards_no_auto = ({session, specificationFields, specFieldOnChange, next}) => cs(

    (({}, next) => next(specificationFields.forEach(field => {
        // If the field is "field_85", update its properties; otherwise if regionName exist then create a new field with the region name.
    if (field.fieldKey === "field_85") {
        field.ordinal = 0;
        field.idDisplayStyle = 6;
        field.data = session.data.region?.regionName?.replace("Prudential ", "");
    } else if (session.data.region?.regionName != '') {
        // Create a new hidden field with the region name
        const newHiddenField = {
            ...field,
            ordinal: 0,
            idPrimary: null,
            fieldKey: "field_85",
            data: session.data.region?.regionName?.replace("Prudential ", ""),
            idDisplayStyle: 6,
        };
        specificationFields.push(newHiddenField);
    }

    }))),
    ["specFieldDuplicates", ({}, next) => next(specificationFields)],
    
    
    (({specFieldDuplicates}, next) => next(specFieldOnChange(specFieldDuplicates))),


    ({specFieldDuplicates}) => next(specFieldDuplicates)
);